import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardContent, CardHeader, Typography, Box, Avatar, CircularProgress } from "@mui/material";
import { Crumbs } from "../Crumbs";

const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

export const UserProfilePage = () => {
    const { documentId } = useParams();
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        fetch(`${BACKEND_HOST}/user-profiles/${documentId}?populate=pic`)
            .then(res => res.json())
            .then(data => {
                setProfile(data.data || null);
                setLoading(false);
            });
    }, [documentId]);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
                <CircularProgress />
            </Box>
        );
    }

    if (!profile) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
                <Typography variant="h6">Profile not found.</Typography>
            </Box>
        );
    }

    return (<Box>
            <Box>
                <Crumbs crumbs={[
                    { title: "Community", href: "/community" },
                    { title: "Profiles", href: "/community/profiles" },
                    { title: profile.name || "Unnamed User" }]} />
            </Box>
            <Box display="flex" justifyContent="center" mt={4}>
                <Card sx={{ minWidth: 320, maxWidth: 400 }}>
                    <CardHeader
                        avatar={
                            profile.pic?.formats?.thumbnail?.url ? (
                                <Avatar
                                    src={profile.pic.formats.thumbnail.url}
                                    alt={profile.name}
                                    sx={{ width: 64, height: 64 }}
                                />
                            ) : (
                                <Avatar sx={{ width: 64, height: 64 }}>{profile.name?.[0]?.toUpperCase() || "?"}</Avatar>
                            )
                        }
                        title={profile.name || "Unnamed User"}
                        subheader={profile.instagram ? `@${profile.instagram}` : ""}
                    />
                    <CardContent>
                        <Typography variant="body2" color="textSecondary">
                            {profile.bio || "No bio provided."}
                        </Typography>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};